/* eslint-disable import/no-cycle */
/* eslint-disable no-unused-vars */
/* eslint import/no-cycle: [2, { maxDepth: 1 }] */
import store from '../store';
import questions from './questions';
import analyticsNames from './analyticsNames';
import * as configs from './configs';
import getLinkToPaymentPage from '../utils/scripts/getLinkToPaymentPage';
import { send } from '../analytics/send';

let transitionTimeout = null;
let transitionBetweenStepsTime;
let preventActionFromFiring = false;
let preventActionTimer;
let dataSended = false;

function getTransitionBetweenStepsTime() {
  return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--transitionBetweenStepsTime').slice(0, -2), 10);
}

const steps = {
  quizStarted: false,
  setup: ({ stepsConfig, currentStep, stepsDetails }) => {
    transitionBetweenStepsTime = getTransitionBetweenStepsTime();
    const stepsList = [];
    const separationStepIndexes = [];
    const hideHeaderStepIndexes = [];
    const hideProgressStepIndexes = [];
    const progressTitlesBySection = [];
    let sectionIndex = 0;

    stepsConfig.forEach((step, index) => {
      stepsList.push(steps.createStep({
        name: step.name,
        showActionBar: stepsDetails[step.name] && stepsDetails[step.name].showActionBar,
      }));

      if (step.separationStep) {
        separationStepIndexes.push(index);

        sectionIndex += 1;

        if (step.progressTitle) {
          progressTitlesBySection[sectionIndex] = step.progressTitle;
        }
      }

      if (step.hideHeader) {
        hideHeaderStepIndexes.push(index);
      }

      if (step.hideProgress) {
        hideProgressStepIndexes.push(index);
      }

      if (index === 0 && step.progressTitle) {
        progressTitlesBySection[0] = step.progressTitle;
      }
    });

    store.dispatch({
      type: 'SET_STEPS',
      payload: stepsList,
    });

    store.dispatch({
      type: 'SET_TOTAL_STEPS',
      payload: stepsList.length,
    });

    store.dispatch({
      type: 'SET_STEPS_META',
      payload: {
        separationStepIndexes,
        hideHeaderStepIndexes,
        hideProgressStepIndexes,
        progressTitlesBySection,
      },
    });

    currentStep && steps.navigate.to(currentStep);
    steps.setCurrentStepIndex();
  },
  createStep: ({ name, showActionBar }) => ({
    name,
    showActionBar,
  }),
  setPreviousAndNextStepsStatus: () => {
    const stepsList = store.getState().steps.list;
    const { currentStepIndex } = store.getState().steps;

    if (stepsList[currentStepIndex - 1]) {
      store.dispatch({
        type: 'SET_PREVIOUS_STEP',
        payload: stepsList[currentStepIndex - 1].name,
      });
    } else {
      store.dispatch({
        type: 'SET_PREVIOUS_STEP',
        payload: null,
      });
    }

    if (stepsList[currentStepIndex + 1]) {
      store.dispatch({
        type: 'SET_NEXT_STEP',
        payload: stepsList[currentStepIndex + 1].name,
      });
    } else {
      store.dispatch({
        type: 'SET_NEXT_STEP',
        payload: null,
      });
    }
  },
  setCurrentStepIndex: () => {
    const stepsList = store.getState().steps.list;
    const { currentStep } = store.getState().steps;
    let currentStepIndex = null;

    stepsList.forEach((step, index) => {
      if (currentStep === step.name) {
        currentStepIndex = index;
      }
    });

    store.dispatch({
      type: 'SET_CURRENT_INDEX',
      payload: currentStepIndex,
    });
  },
  navigate: {
    to: (stepName) => {
      clearTimeout(transitionTimeout);
      document.body.classList.add('onTransition');

      transitionTimeout = setTimeout(() => {
        document.body.classList.remove('onTransition');
      }, transitionBetweenStepsTime + 30);

      store.dispatch({
        type: 'STEP_GO_TO',
        payload: stepName,
      });

      if (store.getState().steps.list) {
        steps.setCurrentStepIndex();
        steps.setPreviousAndNextStepsStatus();
        steps.checkActionBarShowing();
      }

      document.querySelector('#root').scrollTo(0, 0);
    },
    forward: ({ preventAction, numberOfSteps }) => {
      const numberOfStepsValue = numberOfSteps || 1;
      if (preventActionFromFiring) return;
      clearTimeout(preventActionTimer);

      if (preventAction) {
        preventActionFromFiring = true;

        preventActionTimer = setTimeout(() => {
          preventActionFromFiring = false;
        }, preventAction);
      }

      const state = store.getState();
      const stepsList = state.steps.list;
      const { currentStep } = state.steps;
      let stepAfterCurrent = null;

      const answer = questions.getAnswers({ questionName: currentStep === 'customV2_email' ? 'mail' : currentStep }) || {};
      const [keys] = Object.keys(answer);

      if (currentStep === 'customV2_reason' && (answer[keys]?.index === 'v8' || !answer[keys])) {
        stepsList.forEach((step, index) => {
          if (step.name === currentStep && stepsList[index + 3]) {
            stepAfterCurrent = stepsList[index + 3].name;
          }
        });
      } else {
        stepsList.forEach((step, index) => {
          if (step.name === currentStep && stepsList[index + numberOfStepsValue]) {
            stepAfterCurrent = stepsList[index + numberOfStepsValue].name;
          }
        });
      }

      steps.analytics.stepsUpdated({ step: currentStep });

      if (!stepAfterCurrent) {
        try {
          const link = getLinkToPaymentPage();

          setTimeout(() => {
            localStorage.removeItem('bags');
            window.location = link;
          }, 200);
        } catch (e) {
          console.warn('Failed to build payment link:', e);
          store.dispatch({ type: 'TOGGLE_LOADER', payload: false });
        }

        return;
      }

      steps.navigate.to(stepAfterCurrent);
    },
    back: ({ numberOfSteps } = {}) => {
      const numberOfStepsValue = numberOfSteps || 1;
      const stepsList = store.getState().steps.list;
      const { currentStep } = store.getState().steps;
      let stepBeforeCurrent = null;
      
      steps.analytics.send({
        event: {
          event: 'quiz_funnel',
          quiz_action: 'onboarding_back',
          screen_name: currentStep,
        },
      });

      stepsList.forEach((question, index) => {
        if (question.name === currentStep && stepsList[index - numberOfStepsValue]) {
          stepBeforeCurrent = stepsList[index - numberOfStepsValue].name;
        }
      });

      if (!stepBeforeCurrent) {
        console.warn('Can\'t navigate back because you at the start of stepsList');
        return;
      }

      steps.navigate.to(stepBeforeCurrent);
    },
  },
  setStepStatus: ({ stepName, stepStatus }) => {
    const stepsList = store.getState().steps.list;

    stepsList.forEach((step) => {
      if (step.name === stepName) {
        step.isCompleted = stepStatus;
      }
    });

    store.dispatch({
      type: 'SET_STEP_STATUS',
      payload: stepsList,
    });

    steps.setCurrentStepCompletedStatus();
  },
  getStepStatus: ({ stepName }) => {
    const stepsList = store.getState().steps.list;
    let isStepCompled = false;

    stepsList.forEach((step) => {
      if (step.name === stepName) {
        isStepCompled = step.isCompleted;
      }
    });

    return isStepCompled;
  },
  setCurrentStepCompletedStatus: () => {
    const stepsList = store.getState().steps.list;
    const { currentStepIndex } = store.getState().steps;

    store.dispatch({
      type: 'SET_CURRENT_STEP_COMPLETED_STATUS',
      payload: stepsList[currentStepIndex].isCompleted,
    });
  },
  checkActionBarShowing: () => {
    const stepsList = store.getState().steps.list;
    const { currentStepIndex } = store.getState().steps;
    const actionBarShowed = stepsList[currentStepIndex].showActionBar;

    if (actionBarShowed) {
      document.body.classList.add('showActionBar');
    } else {
      document.body.classList.remove('showActionBar');
    }

    store.dispatch({
      type: 'CHECK_ACTION_BAR_SHOWING',
      payload: actionBarShowed,
    });
  },
  userMovedToNextStepByClick: ({ byNextStep }) => {
    const { nextStep } = store.getState().steps;
    const { currentStep } = store.getState().steps;
    const step = byNextStep ? nextStep : currentStep;

    if (step === 'mail' && document.querySelector('#mail')) {
      document.querySelector('#mail').focus();

      setTimeout(window.scrollTo(0, -285), 100);
      // setTimeout(() => {
      //   window.scrollTo(0, document.querySelector('#mail').getBoundingClientRect().top);
      // }, 100);
    }
  },
  userMovedToPreviousStepByClick: () => {
    const { currentStep } = store.getState().steps;

    if (currentStep === 'mail' && document.querySelector('#mail')) {
      document.querySelector('#mail').focus();
      setTimeout(window.scrollTo(0, -285), 100);
    }
  },
  
  analytics: {
    stepsUpdated({ step }) {
      const answer = questions.getAnswers({ questionName: step });
      const { currentStepIndex } = store.getState().steps;
      const { totalSteps } = store.getState().steps;
      const isItLastStep = currentStepIndex === (totalSteps - 1);
      const { savedAnswers } = store.getState().questions;
      const dataToSend = {};
      const { currentStep } = store.getState().steps;
      const { previousStep } = store.getState().steps;

      if (isItLastStep) {
        steps.analytics.send({
          event: {
            event: 'funnel on onboarding',
            quiz_action: 'quiz end',
          },
        });

        // Remove all empty answers and add data to dataToSend object
        Object.entries(savedAnswers).forEach((el) => {
          if (Object.keys(el[1]).length !== 0) {
            dataToSend[`${el[0]}`] = {};

            // eslint-disable-next-line prefer-destructuring
            dataToSend[el[0]].answers = el[1];
          }
        });

        if (dataSended) return;
        dataSended = true;

        // fetch(`${process.env.REACT_APP_API_URL}/v4/web_extra_data`, {
        //   method: 'POST',
        //   body: JSON.stringify({
        //     bundle_id: 'com.verv.app',
        //     extra_data: {
        //       user_data: dataToSend,
        //     },
        //   }),
        // }).then((response) => response.json())
        //   .then((response) => {
        //     store.dispatch({
        //       type: 'SET_PROMOCODE',
        //       payload: response.data.promocode,
        //     });
        //   });
      }

      if (currentStepIndex === 1 && configs.stepsDetails[previousStep]?.welcome_loader && !steps.quizStarted) {
        steps.quizStarted = true;
        steps.analytics.send({
          event: {
            event: 'quiz_funnel',
            quiz_action: 'start_quiz',
          },
        });
      }

      if (!steps.quizStarted && !configs.stepsDetails[currentStep]?.welcome_loader) {
        steps.quizStarted = true;
        steps.analytics.send({
          event: {
            event: 'quiz_funnel',
            quiz_action: 'start_quiz',
          },
        });
      }

      if (answer && answer.value && answer.units) {
        steps.analytics.send({
          event: {
            event: 'onboarding_question',
            quiz_question: analyticsNames[step],
            quiz_answer: answer.value.value,
            quiz_answer_units: answer.units.value,
          },
        });

        return;
      }

      let answers;

      if (step === 'mail') {
        const mail = questions.getAnswers({ questionName: 'mail' });
        const agreeToInbox = questions.getAnswers({ questionName: 'mail' }).agreeToInbox || true;

        steps.analytics.send({
          event: {
            event: 'onboarding_question',
            quiz_question: 'User has agreed to inbox',
            quiz_answer: agreeToInbox,
          },
        });

        steps.analytics.send({
          event: {
            email: mail.value,
          },
        });

        if (window.web_platform === 'facebook_web' && window.fbq) {
          window.fbq('track', 'contact');
        }

        steps.analytics.send({
          event: {
            event: 'funnel on onboarding',
            quiz_action: 'email send',
            payment_type: mail.value,
          },
        });

        return;
      }

      if (step === 'customV2_name') {
        const name = questions.getAnswers({ questionName: 'customV2_name' });
        const nameVal = Object.keys(name)[0];

        if (nameVal) {
          steps.analytics.send({
            event: {
              event: 'onboarding_question',
              quiz_question: 'name',
              quiz_answer: nameVal,
            },
          });
        } else {
          steps.analytics.send({
            event: {
              event: 'onboarding_question',
              quiz_question: 'name',
              quiz_answer: 'not_say',
            },
          });
        }

        return;
      }

      if (step === 'customV2_date') {
        const date = questions.getAnswers({ questionName: 'customV2_date' });
        const dateVal = Object.keys(date)[0];

        if (dateVal) {
          steps.analytics.send({
            event: {
              event: 'onboarding_question',
              quiz_question: 'date',
              quiz_answer: dateVal,
            },
          });
        } else {
          steps.analytics.send({
            event: {
              event: 'onboarding_question',
              quiz_question: 'date',
              quiz_answer: 'none',
            },
          });
        }

        return;
      }

      if (step === 'customV2_breed') {
        const breed = questions.getAnswers({ questionName: 'customV2_breed' });
        const breedVal = Object.keys(breed)[0];

        if (breedVal) {
          steps.analytics.send({
            event: {
              event: 'onboarding_question',
              quiz_question: 'breed',
              quiz_answer: breedVal?.toLowerCase()?.replace(/ /g, '_'),
            },
          });
        } else {
          steps.analytics.send({
            event: {
              event: 'onboarding_question',
              quiz_question: 'breed',
              quiz_answer: 'dont_know',
            },
          });
        }

        return;
      }

      if (configs.stepsDetails[currentStep]?.continue) {
        steps.analytics.send({
          event: {
            event: 'onboarding_question',
            quiz_question: analyticsNames[step],
            quiz_answer: 'continue',
          },
        });
        return;
      }

      if (configs.stepsDetails[currentStep]?.welcome_loader) {
        steps.analytics.send({
          event: {
            event: 'onboarding_question',
            quiz_question: 'welcome_loader',
            quiz_answer: 'none',
          },
        });
        return;
      }

      if (answer && Object.keys(answer).length > 1) {
        answers = [];
        Object.keys(answer).forEach((key) => {
          if (answer[key] && answer[key].a_value) {
            answers.push(answer[key].a_value);
          }
        });
      } else if (answer) {
        const answerValue = Object.keys(answer)[0];
        const aValue = answer[answerValue]?.a_value;
        answers = aValue;
        if (!answers && currentStep !== 'customV2_startPage' && currentStep !== 'customV2_startPageV3' && currentStep !== 'customV2_startPageV4' && currentStep !== 'customV2_startPageV11' && currentStep !== 'customV2_startPageV12' && currentStep !== 'customV2_startPageV13' && currentStep !== 'customV2_startPageV17' && currentStep !== 'customV2_startPageV18' && currentStep !== 'customV2_startPageV19' && currentStep !== 'customV2_startPageV20' && currentStep !== 'customV2_startPageV21' && currentStep !== 'customV2_startPageV22' && currentStep !== 'customV2_startPageV23' && currentStep !== 'customV2_startPageV24' && currentStep !== 'customV2_startPageV26' && currentStep !== 'customV2_startPageV27' && currentStep !== 'customV2_startPageV28' && currentStep !== 'customV2_startPageV29' && currentStep !== 'customV2_startPageV30' && currentStep !== 'customV2_startPageV31') {
          answers = 'none';
        }
      }

      if (answers) {
        steps.analytics.send({
          event: {
            event: 'onboarding_question',
            quiz_question: analyticsNames[step],
            quiz_answer: answers,
          },
        });
      }

      if (configs.stepsDetails[currentStep]?.continueAuto) {
        steps.analytics.send({
          event: {
            event: 'onboarding_question',
            quiz_question: analyticsNames[step],
            quiz_answer: 'continueAuto',
          },
        });
      }
    },
    send,
  },
  addStepToEnd: ({ name, showActionBar = false }) => {
    const stepsList = store.getState().steps.list || [];

    const newStep = steps.createStep({ name, showActionBar });
    const updatedSteps = [...stepsList, newStep];

    store.dispatch({
      type: 'SET_STEPS',
      payload: updatedSteps,
    });

    store.dispatch({
      type: 'SET_TOTAL_STEPS',
      payload: updatedSteps.length,
    });

    steps.setPreviousAndNextStepsStatus();
    steps.setCurrentStepIndex();
  },
};

export default steps;
